export const mockTextInputControlProperty = {
  type: 'string',
  title: 'Text Input Control',
  'x-entity-label': {
    key: 'MOCK_SIMPLE_SCHEMA_PRIMITIVE_TEXT_LABEL',
  },
  description: 'This is where you enter text',
  'x-entity-presentation': {
    hidden: false,
    hint: '',
  },
};

export const mockRichTextInputControlProperty = {
  type: 'string',
  format: 'rich-text',
  title: 'Rich Text Input Control',
  description: 'This is where you enter text',
  'x-entity-label': {
    key: 'MOCK_RICHTEXT_INPUT_CONTROL_LABEL',
  },
  'x-entity-presentation': {
    hidden: false,
    hint: '',
  },
};

export const mockJsonLogicInputControlProperty = {
  type: 'string',
  format: 'json-logic',
  title: 'Rule Input Control',
  description: 'This is where you enter text',
  'x-entity-presentation': {
    hidden: false,
    hint: {
      key: 'JSON_LOGIC_HINT',
    },
  },
};

export const mockDateInputControlProperty = {
  title: 'Date Input Control',
  type: 'string',
  format: 'date',
};

export const mockDateTimeInputControlProperty = {
  title: 'DateTime Input Control',
  type: 'string',
  format: 'date-time',
};

export const mockSelectInputControlProperty = {
  title: 'Select Input Control',
  type: 'string',
  'x-entity-presentation': {
    enumLabels: {
      enumControlPlaceholder: 'PICK_SOMETHING',
      this: 'THIS',
      that: 'THAT',
      theother: 'THE_OTHER',
    },
  },
  enum: ['this', 'that', 'theother'],
};

export const mockNumberInputControlProperty = {
  title: 'Number Input Control',
  type: 'number',
  multipleOf: 0.1,
};

export const mockIntegerInputControlProperty = {
  title: 'Integer Input Control',
  type: 'integer',
  multipleOf: 1,
};

export const mockBooleanInputControlProperty = {
  title: 'Boolean Input Control',
  type: 'boolean',
};
